import { computed } from 'vue'

import { SortKey } from '@/typings/twitter_benchmark_campaign_posts'

import { useTwBenchmarkPostsStore } from '../store/useTwBenchmarkPostsStore'

type SortOrder = 'asc' | 'desc'

const DEFAULT_ORDER: SortOrder = 'desc'

/**
 * 一覧のソート状態を管理する（ストアが単一情報源で、URL 反映は TwBenchmark.vue の watch が担う）。
 */
export function useTableSort() {
  const postsStore = useTwBenchmarkPostsStore()

  const currentSort = computed<{ sortBy: SortKey; order: SortOrder }>(() => ({
    sortBy: postsStore.sortBy,
    order: postsStore.order
  }))

  const changeSort = (sortBy: SortKey): void => {
    const nextOrder: SortOrder =
      postsStore.sortBy === sortBy ? (postsStore.order === 'asc' ? 'desc' : 'asc') : DEFAULT_ORDER

    void postsStore.setSort(sortBy, nextOrder)
  }

  const isSorted = (sortBy: SortKey): boolean => postsStore.sortBy === sortBy

  const sortOrderOf = (sortBy: SortKey): SortOrder | null => (postsStore.sortBy === sortBy ? postsStore.order : null)

  return {
    currentSort,
    changeSort,
    isSorted,
    sortOrderOf
  }
}
